export default __webpack_public_path__ + "img/fos-open-scouting.29e9f0c5.svg";